'use client';
import { Breadcrumb } from 'rsuite';

type Props = {
  data: Array<{
    title: string | undefined | null;
    link: string;
  }>; // Array of breadcrumb items with title and link properties
  children?: React.ReactNode; // Optional child component to render in the breadcrumbs
};

const Breadcrumbs = ({ data }: Props) => {
  return (
    <div>
      <Breadcrumb separator="\" classPrefix="my-breadcrumb">
        {data.map((item: any, index) => {
          const isLast = index === data.length - 1;
          return (
            <Breadcrumb.Item
              classPrefix="my-breadcrumb-item"
              key={index}
              href={!isLast && item.link ? item.link : undefined}
            >
              {item.title}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
};

export default Breadcrumbs;
